import React, { useState } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";

function ViewSchoolDetails() {
    const formattedTitle = useLocation().pathname
        .split('/').pop()
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
    const navigate = useNavigate();

    return (
        <>
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <section className="content-header">
                                        <h1>View School Details
                                        </h1>
                                        <ol className="breadcrumb">
                                            <li>
                                                <a onClick={() => navigate("/admin-dashboard")} style={{ cursor: "pointer" }}>
                                                    <i className="fa fa-tachometer" style={{ marginRight: "5px" }}></i> Home
                                                </a>
                                            </li>
                                            <li className="active">{formattedTitle}</li>
                                        </ol>
                                        <h3 />
                                    </section>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mb-4 stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h4><i className="fa fa-university text-primary" /> School Details</h4>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-condensed">
                                                                <tbody>
                                                                    <tr>
                                                                        <td><b>Name of School :</b></td>
                                                                        <td>Chinchuria Upendra Nath High School</td>
                                                                        <td><b>Area :</b></td>
                                                                        <td>Rural</td>
                                                                        <td><b>State :</b></td>
                                                                        <td>Jharkhand</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>District :</b></td>
                                                                        <td>Ranchi</td>
                                                                        <td><b>Block :</b></td>
                                                                        <td>Govindpur</td>
                                                                        <td><b>Pin :</b></td>
                                                                        <td>717171</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>Address :</b></td>
                                                                        <td colSpan={5} />
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <h4 className="mt-4"><i className="fa fa-map-marker text-danger " /> Affiliation Details
                                                    </h4>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-condensed">
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ width: '16.66%' }}><b>Administration :</b></td>
                                                                        <td style={{ width: '16.66%' }}>Government</td>
                                                                        <td style={{ width: '16.66%' }}><b>Type of School :</b></td>
                                                                        <td style={{ width: '16.66%' }}>English</td>
                                                                        <td style={{ width: '16.66%' }}><b>Registered Under RTE :</b></td>
                                                                        <td style={{ width: '16.66%' }}>Yes</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>RTE Registration Number :</b></td>
                                                                        <td>8828882</td>
                                                                        <td><b>Date of Issuing Certificate :</b></td>
                                                                        <td>10-09-2024</td>
                                                                        <td><b /></td>
                                                                        <td />
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <h4 className="mt-4"><i className="fa fa-address-card-o text-success" /> Tagged Classes
                                                        Details</h4>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-condensed">
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ width: '16.66%' }}><b>Class :</b></td>
                                                                        <td style={{ width: '16.66%' }} colSpan={5}>Class IX, Class X</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <h4 className="mt-4"><i className="fa fa-phone text-warning" /> School Contact Details
                                                    </h4>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-condensed">
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ width: '25%' }}><b>Principal / Headmaster Name :</b></td>
                                                                        <td style={{ width: '25%' }} />
                                                                        <td style={{ width: '25%' }}><b>Principal / Headmaster Mobile Number :</b></td>
                                                                        <td style={{ width: '25%' }} />
                                                                    </tr>
                                                                    <tr>
                                                                        <td><b>Assistant Teacher's Mobile Number :</b></td>
                                                                        <td />
                                                                        <td><b>School's Email ID :</b></td>
                                                                        <td />
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <h4 className="mt-4"><i className="fa fa-cloud-upload text-secondary" /> Uploaded
                                                        Details</h4>
                                                    <hr />
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <table className="table table-bordered table-striped table-condensed">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Attachment Type</th>
                                                                        <th>Attachment Description</th>
                                                                        <th>Uploaded File</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Minority</td>
                                                                        <td>PDF</td>
                                                                        <td><a href="#">abcd.pdf</a></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>UDISE</td>
                                                                        <td>JPG</td>
                                                                        <td><a href="#">efgh.pdf</a></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Govt Affiliation</td>
                                                                        <td>JPG</td>
                                                                        <td><a href="#">efgh.pdf</a></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <a className="btn btn-primary" style={{ float: 'right' }} href="add-school.html">
                                                <i className="fa fa-edit" /> Edit
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewSchoolDetails